import React from "react";
import { useParams } from "react-router";
import { CircularProgress } from "@sscs/ui";
import { LoginContentWrapper } from "Components";
import PasswordResetLayout from "../../components/PasswordResetLayout";
import { useEmailConfirmation } from "../../hooks";

const EmailConfirmation = (): React.JSX.Element => {
  const { verificationToken } = useParams();

  const { isConfirmed, hasConfirmationFailed, isConfirming, error } =
    useEmailConfirmation(verificationToken);

  if (hasConfirmationFailed)
    return (
      <PasswordResetLayout>
        <LoginContentWrapper title="Email confirmation failed">
          {error ? (
            <div>{error}</div>
          ) : (
            <div>
              {
                'You can still use "Forgot my password" to reset your password and activate your account'
              }
            </div>
          )}
        </LoginContentWrapper>
      </PasswordResetLayout>
    );

  if (isConfirmed)
    return (
      <PasswordResetLayout>
        <LoginContentWrapper
          title="Email confirmed!"
          byline="You can now log in with your confirmed email and password."
        />
      </PasswordResetLayout>
    );

  const title = isConfirming ? "Activating account..." : "Account activation";

  return (
    <PasswordResetLayout>
      <LoginContentWrapper title={title}>
        {isConfirming ? <CircularProgress size="large" /> : <></>}
      </LoginContentWrapper>
    </PasswordResetLayout>
  );
};

export default EmailConfirmation;
